import { PageHeader } from "@/components/Common";
import { DocumentCenter, RequestsPanel } from "@/components/DocumentCenter";
import { useAuth } from "@/context/AuthContext";

export default function Documents() {
  const { user } = useAuth();
  const type = user?.role === "candidate" ? "candidate" : "business";
  return (
    <div>
      <PageHeader eyebrow="Secure file exchange" title="Documents" desc={type === "candidate"
        ? "Upload your resume, licenses and certificates, and respond to private file requests from businesses."
        : "Submit files to our team, and request or receive private documents from candidates."} />
      <DocumentCenter ownerType={type} />
    </div>
  );
}

export const AdminDocRequests = () => <RequestsPanel admin />;
